import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium leading-6 text-gray-900"
}
const _hoisted_2 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs mt-1 text-red-600 sm:col-span-2 sm:items-end sm:col-start-2"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import VueDatePicker from "@vuepic/vue-datepicker";
import { useField, useFieldError } from "vee-validate";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeField',
  props: {
  name: {
    type: String as PropType<string>,
    required: true,
  },
  range: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  autoApply: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  placeholder: {
    type: String as PropType<string>,
    default: "dd.mm.yyyy - dd.mm.yyyy",
  },
  inlineField: {
    type: Boolean as PropType<boolean>,
    required: false,
  },
  label: {
    type: String,
  },
},
  setup(__props) {

const props = __props;

// Setup for validation and error handling
const errorMessage = useFieldError(props.name);
const { value, setValue, validate } = useField<Date[]>(props.name);

// Handle date picker changes
const handleChange = (newValue: Date[]) => {
  if (newValue) {
    setValue([...newValue]);
    validate();
  }
};

const lang = localStorage.getItem("lang") || "de";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'sm:grid sm:grid-cols-3 sm:gap-x-4 sm:items-center': __props.inlineField })
    }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
          'relative mt-2 sm:mt-0 rounded-md shadow-sm',
          { 'sm:col-span-2 max-w-lg sm:max-w-xs': __props.inlineField },
        ])
      }, [
        _createVNode(_unref(VueDatePicker), {
          name: "range",
          modelValue: _unref(value),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
            handleChange
          ],
          "enable-time-picker": false,
          "auto-apply": __props.autoApply,
          range: __props.range,
          "input-class-name": _unref(errorMessage) ? 'dp-custom-input dp-error' : 'dp-custom-input',
          "menu-class-name": "dp-custom-menu",
          locale: _unref(lang),
          format: "dd.MM.yyyy",
          placeholder: __props.placeholder
        }, null, 8, ["modelValue", "auto-apply", "range", "input-class-name", "locale", "placeholder"]),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(ExclamationCircleIcon), {
                class: "h-5 w-5 text-red-500",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})